import { Injectable } from '@angular/core';
import { MtrmbServicePkg } from './mtrmbPkg.service';

@Injectable({
  providedIn: 'root',
})
export class MtrmbService extends MtrmbServicePkg {
  constructor() {
    super();
  }
}
